export const VERIFY_AUTH = "/auth/verify/";
export const FETCH_PROFILE = "/profile/";
export const UPDATE_PROFILE = "/profile/update/";
